import { CalculationTypeEnum, EntityStatusEnum, TableUpdates } from 'src/types.d';

const SMALL = 20;
const LARGE = 35;

// the map marker for the maps
export const map_marker = (color, size) => {
  const encodedColor = encodeURIComponent(color);

  // return {
  //   url: `data:image/svg+xml;utf-8, \
  //   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="${size}" height="${size}">
  //     <circle cx="15" cy="15" r="15" fill="${encodedColor}"  />
  //   </svg>`,
  // };

  return {
    url: `data:image/svg+xml;utf-8, \
    <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 502 502" style="enable-background:new 0 0 502 502;" xml:space="preserve">
<g>
	<g>
		<path style="fill:${encodedColor};" d="M251,10C166.429,10,97.87,78.559,97.87,163.13S251,492,251,492s153.13-244.299,153.13-328.87
			S335.571,10,251,10z M251,239.181c-42.002,0-76.051-34.049-76.051-76.051S208.998,87.079,251,87.079s76.051,34.049,76.051,76.051
			S293.002,239.181,251,239.181z"/>
		<path d="M251,502c-3.443,0-6.645-1.771-8.473-4.689C236.212,487.236,87.87,249.582,87.87,163.13C87.87,73.18,161.05,0,251,0
			s163.13,73.18,163.13,163.13c0,86.452-148.342,324.106-154.657,334.181C257.645,500.229,254.443,502,251,502z M251,20
			c-78.922,0-143.13,64.208-143.13,143.13c0,32.929,26.05,99.093,75.333,191.34c27.067,50.662,54.401,96.442,67.797,118.444
			c13.396-22.001,40.729-67.782,67.797-118.444c49.283-92.247,75.333-158.412,75.333-191.34C394.13,84.208,329.922,20,251,20z
			 M251,249.181c-47.448,0-86.051-38.603-86.051-86.051S203.552,77.079,251,77.079s86.051,38.602,86.051,86.051
			S298.448,249.181,251,249.181z M251,97.079c-36.421,0-66.051,29.63-66.051,66.051s29.63,66.051,66.051,66.051
			s66.051-29.63,66.051-66.051S287.421,97.079,251,97.079z"/>
	</g>
</g>
</svg>
    `,
  };
};

export const LanguageToDirection = {
  en: 'ltr',
  heb: 'rtl',
};

export const screenWidthDimension = {
  // xSmall: 900,
  xSmall: 600,
  // small: 1300,
  small: 768,
  // laptop: 1367,
  laptop: 992,
  // large: 1550,
  large: 1200,
};

export const graphTypes = [
  'distribution',
  'occupancy',
  'rent',
  'rent_growth',
  'rent_full_occupancy',
  'assets',
  'loans',
  'roi',
  'noi',
  'roe',
  'coc',
  'ltc',
];

export const graphTypesLabelNameDict = tab => {
  const dict = {
    distribution: 'distribution graph',
    occupancy: 'occupancy graph',
    rent_full_occupancy: 'rent full occupancy',
    rent: 'rent graph',
    rent_growth: 'rent growth',
    assets: 'capex',
    loans: 'loans graph',
    roi: 'roi graph',
    noi: 'noi graph',
    roe: 'roe graph',
    coc: 'coc graph',
    ltc: 'ltc graph',
  };
  return dict[tab];
};

export const projectsTypeColorDict = {
  industrial: {
    color: '#808080',
    icon: map_marker('#808080', SMALL),
    bigIcon: map_marker('#808080', LARGE),
  },
  'office buildings': {
    color: '#2E40DD',
    icon: map_marker('#2E40DD', SMALL),
    bigIcon: map_marker('#2E40DD', LARGE),
  },
  'raw land': {
    color: '#9C27B0',
    icon: map_marker('#9C27B0', SMALL),
    bigIcon: map_marker('#9C27B0', LARGE),
  },
  residential: {
    color: '#1f5a8f',
    icon: map_marker('#1f5a8f', SMALL),
    bigIcon: map_marker('#1f5a8f', LARGE),
  },
  commercial: {
    color: '#000000',
    icon: map_marker('#000000', SMALL),
    bigIcon: map_marker('#000000', LARGE),
  },
  development: {
    color: '#548235',
    icon: map_marker('#548235', SMALL),
    bigIcon: map_marker('#548235', LARGE),
  },
  custom: {
    color: '#fc5b96',
    icon: map_marker('#fc5b96', SMALL),
    bigIcon: map_marker('#fc5b96', LARGE),
  },
  other: {
    color: '#ff0000',
    icon: map_marker('#ff0000', SMALL),
    bigIcon: map_marker('#ff0000', LARGE),
  },
  fund: {
    color: '#9f0000',
    icon: map_marker('#9f0000', SMALL),
    bigIcon: map_marker('#9f0000', LARGE),
  },
  mixed: {
    color: '#39c0f0',
    icon: map_marker('#39c0f0', SMALL),
    bigIcon: map_marker('#39c0f0', LARGE),
  },
};

export const defaultUpdatesObject: TableUpdates = {
  dataToShow: ['reportDate', 'title'],
  values: [],
};

export const defaultCategories = ['residential', 'commercial', 'industrial', 'development'];

//Defines the default strategies
export const defaultStrategies = [
  'Development',
  'Passive Income',
  'Renovation',
  'Bridge Loan',
  'Mezzanine Loan',
  'Equity Loan',
  'Zoning',
];

export const currencyOptions = ['USD', 'EUR', 'GBP', 'ILS', 'CHF', 'CAD'];

export const currencyDict = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  ILS: '₪',
  CHF: 'CHF',
  CAD: 'C$',
};

//Export the available options for project status
export const statusOptions = [
  {
    label: EntityStatusEnum.STARTED,
    description: 'Active project, still being managed',
  },
  {
    label: EntityStatusEnum.COMPLETED,
    description: 'Ended project, existed or stopped, not being managed',
  },
  {
    label: EntityStatusEnum.CANCELLED,
    description: 'Cancelled project, discarded',
  },
];

export const kpiOptions = [
  {
    label: CalculationTypeEnum.ROI,
    description: 'total annual return divided by the original amount invested',
  },
  // {
  //   label: 'ROE',
  //   description: 'total annual return divided by the current equity owned in the property',
  // },
  {
    label: CalculationTypeEnum.IRR,
    description:
      'Calculates the internal rate of return of an investment based on a series of periodic cash flows',
  },
  {
    label: CalculationTypeEnum.XIRR,
    description:
      'Calculates the internal rate of return of an investment based on a specified series of potentially irregularly spaced cash flows',
  },
];

export const profimexKpiOptions = [
  {
    label: CalculationTypeEnum.NET_COC,
    description: '',
  },
  {
    label: CalculationTypeEnum.GROSS_COC,
    description: '',
  },
  {
    label: CalculationTypeEnum.NET_IRR,
    description: '',
  },
  {
    label: CalculationTypeEnum.GROSS_IRR,
    description: '',
  },
  {
    label: CalculationTypeEnum.NET_ROI,
    description: '',
  },
  {
    label: CalculationTypeEnum.GROSS_ROI,
    description: '',
  },
];

// extra random data is added to keys in order to avoid collisions with possible future keys
export const VIEW_AS_EMAIL_KEY = 'view-as-email-key_dfdsdfdfsdf44';
export const DASHBOARD_ROUTES_KEY = 'dasbhoard-routes_dsdj32ddsf';
export const INVESTMENTS_KEY = 'investments_dsdjld323dsd';
export const SELECTED_TAB_KEY = 'investor-manager-tab_233323ddfdfs_ds3';
